import { differenceInMinutes } from "date-fns";
import { VctTicket } from "./AdminTrack.interfaces";

export const VtcTicketConvertResponse = (res: VctTicket) => {
  const tickets = res.appointments.map((detail) => {
    const dateNow = new Date();
    const turnStatusEnabled =
      detail.turn_status.option === "calling" ||
      detail.turn_status.option === "waiting";
    const diffInMinutes = turnStatusEnabled
      ? differenceInMinutes(
          new Date(),
          new Date(detail.dock_call_time ? detail.dock_call_time : dateNow)
        )
      : null;
    const statusTurn = turnStatusEnabled && detail.dock_call_time;
    const invertDiffInMinutes = diffInMinutes * -1;
    return {
      id: detail.appointment_id,
      appointmentNum: detail.appointment_num,
      volantes: detail.volantes,
      groupsNum: detail.groups_num_sum,
      parcelsWeight: detail.parcels_weight_sum,
      dispatcherId: detail.customs_dispatcher_json["external_id"],
      dispatcherDocumentNumber:
        detail.customs_dispatcher_json["document_number"],
      dispatcherName: detail.customs_dispatcher_json["full_name"],
      appointmentStatus: detail.turn_status,
      segmentCategory: detail.segment_category,
      vehicles: detail.vehicles,
      timeslot: detail.timeslot,
      vctId: detail.vct_id,
      dockNum: detail.dock_num,
      withdrawalDate: detail.withdrawal_date,
      agentName: detail.agent_name,
      turnNum: detail.turn_num,
      objectStatus: detail.object_status,
      plates: detail.vehicles.map((vehicle) => vehicle.plate),
      dateNow,
      diffInMinutes: invertDiffInMinutes,
      redCountDownMinutes: detail?.red_countdown_minutes
        ? detail?.red_countdown_minutes
        : 5,
      statusTurn,
      statusQuote: detail.object_status,
    };
  });

  return {
    tickets,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    page: res.page,
  };
};
